import GenderSelect from './GenderSelect';
import { Form } from './';
import { formPropTypes } from './common';

import React from 'react';

const BodyweightCategoryForm = ({ formProps, values, meta, onInputChange }) => (
  <Form {...formProps}>
    <Form.Field
      control={GenderSelect}
      name="gender"
      value={values.gender}
      meta={meta}
      onChange={onInputChange}
      label="Gender"
      required
      fluid
    />
    <Form.Group widths="equal">
      <Form.Input
        name="title"
        value={values.title}
        meta={meta}
        onChange={onInputChange}
        label="Title"
        placeholder="Title"
        required
        fluid
      />
      <Form.Input
        name="abbreviation"
        value={values.abbreviation}
        meta={meta}
        onChange={onInputChange}
        label="Abbreviation"
        placeholder="Abbreviation"
        required
        fluid
      />
    </Form.Group>
    <Form.Group widths="equal">
      <Form.Input
        name="bodyweightMinimum"
        value={values.bodyweightMinimum}
        meta={meta}
        onChange={onInputChange}
        label="Bodyweight minimum"
        placeholder="Bodyweight minimum"
        fluid
      />
      <Form.Input
        name="bodyweightMaximum"
        value={values.bodyweightMaximum}
        meta={meta}
        onChange={onInputChange}
        label="Bodyweight maximum"
        placeholder="Bodyweight maximum"
        fluid
      />
    </Form.Group>
  </Form>
);

BodyweightCategoryForm.propTypes = formPropTypes;

export default BodyweightCategoryForm;



// WEBPACK FOOTER //
// ./src/components/BodyweightCategoryForm.js